import React, { memo } from 'react'
import clsx from 'clsx'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import sx from './styles'

const Tile = (props) => {
  const {
    id,
    sx: sxProp,
    className: classNameProp,
    selected,
    icon = null,
    text,
    title = '',
    onClick,
    children = null,
    variant = 'flexible',
    sxIcon = {},
    sxText = {},
    ...others
  } = props

  const Component = typeof onClick === 'function' ? ButtonBase : Box

  const rowColumn = clsx({
    row: variant === 'row',
    column: variant === 'column',
    flexible: variant === 'flexible',
    selected,
  })

  return (
    <Component
      id={id}
      className={clsx('Tile-root', classNameProp, rowColumn)}
      onClick={onClick}
      title={title}
      sx={{
        ...sx.root,
        ...sxProp,
      }}
      {...others}
    >
      {icon && (
        <Box
          sx={{ ...sx.iconContainer, ...sxIcon }}
          className={clsx('Tile-icon', rowColumn)}
        >
          {icon}
        </Box>
      )}
      <Text
        sx={{ ...sx.textContainer, ...sxText }}
        component="span"
        type={icon ? TEXT_TYPES.body.x1 : TEXT_TYPES.body.x2}
        className="Tile-text"
      >
        {text}
      </Text>
      {children}
    </Component>
  )
}

export default memo(Tile)
